import { render, staticRenderFns } from "./IoTVRF.vue?vue&type=template&id=c0a79460&scoped=true"
import script from "./IoTVRF.vue?vue&type=script&lang=js"
export * from "./IoTVRF.vue?vue&type=script&lang=js"
import style0 from "./IoTVRF.vue?vue&type=style&index=0&id=c0a79460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a79460",
  null
  
)

export default component.exports